import { Component, input, output, inject, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cancel-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cancel-dialog.html',
    styleUrl: './cancel-dialog.scss',
})
export class CancelDialog {
  private localeId = inject(LOCALE_ID);

  visible = input.required<boolean>();
  confirm = output<void>();
  dismiss = output<void>();

  get isArabic(): boolean {
    return this.localeId.startsWith('ar');
  }
}